document.addEventListener('DOMContentLoaded', function () {
  function sortAppSwatches() {
    if (!document.body.classList.contains('template-product')) return;

    const groups = document.querySelectorAll('ul.swatch-view.swatch-view-image');

    groups.forEach(function (group) {
      if (group.dataset.swatchesSorted === 'true') return;

      const items = Array.from(group.querySelectorAll(':scope > li.swatch-view-item'));
      if (items.length < 2) return;

      const sorted = items.slice().sort(function (a, b) {
        const aText = (a.getAttribute('orig-value') || '').trim();
        const bText = (b.getAttribute('orig-value') || '').trim();

        return aText.localeCompare(bText, 'ro-RO', {
          sensitivity: 'base',
          numeric: true
        });
      });

      let changed = false;

      for (let i = 0; i < items.length; i++) {
        if (items[i] !== sorted[i]) {
          changed = true;
          break;
        }
      }

      if (changed) {
        sorted.forEach(function (item) {
          group.appendChild(item);
        });
      }

      group.dataset.swatchesSorted = 'true';
    });
  }

  sortAppSwatches();

  setTimeout(sortAppSwatches, 500);
  setTimeout(sortAppSwatches, 1200);
  setTimeout(sortAppSwatches, 2000);
});